import Vue from "vue";
import Router from "vue-router";

import store from "@/store";

// Auth Pages
import VerifyEmail from "@/views/auth/VerifyEmail.vue";
import Onboarding from "@/views/onboarding/";
import Login from "@/views/auth/Login.vue";
import Register from "@/views/auth/Register.vue";
import RegisterWithReferral from "@/views/auth/RegisterWithReferral.vue";
import ResetPassword from "@/views/auth/ResetPassword.vue";
import ForgotPassword from "@/views/auth/ForgotPassword.vue";

// Error Pages
import Error404 from "@/views/error/404.vue";

import Dashboard from "@/views/dashboard";
import Ownerships from "@/views/ownerships";
import Rentals from "@/views/rentals";
import Investments from "@/views/investments";
import Farms from "@/views/farms";
import ActiveFarms from "@/views/farms/components/plans";
//import InvestmentAbout from "@/views/investments/InvestmentAbout";
import Profile from "@/views/profile";
import Wallet from "@/views/wallet";
import Slots from "@/views/slots";
import Referrals from "@/views/referrals";

import Edibles from "@/views/edibles";


import { isUserLoggedIn } from "@/utils/auth";
import * as ROUTES from "./routes";

Vue.use(Router);

// Seperated into const so as to put route guards
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: ROUTES.LOGIN
    },
    {
      path: ROUTES.LOGIN,
      name: "login",
      component: Login,
      meta: {
        title: "Login",
        requiresAuth: false
      }
    },
    {
      path: ROUTES.REGISTER,
      name: "register",
      component: Register,
      meta: {
        title: "Register",
        requiresAuth: false
      }
    },
    {
      path: ROUTES.ONBOARDING,
      name: "onboarding",
      component: Onboarding,
      meta: {
        title: "Verify Account",
        requiresAuth: true
      }
    },
    {
      path: ROUTES.REGISTER_WITH_REFERRAL_LINK,
      name: "register-with-referral-link",
      component: RegisterWithReferral,
      meta: {
        title: "Register With Referral Link",
        requiresAuth: false
      }
    },
    {
      path: ROUTES.FORGOT_PASSWORD,
      name: "forgotPassword",
      component: ForgotPassword,
      meta: {
        title: "Forgot Password",
        requiresAuth: false
      }
    },
    {
      path: ROUTES.RESET_PASSWORD,
      name: "resetPassword",
      component: ResetPassword,
      meta: {
        title: "Reset Password"
      }
    },
    {
      path: ROUTES.VERIFY_EMAIL,
      name: "verifyEmail",
      component: VerifyEmail,
      meta: {
        title: "Email Verification"
      }
    },
    {
      path: ROUTES.DASHBOARD,
      name: "dashboard",
      component: Dashboard,
      meta: {
        title: "Dashboard",
        requiresAuth: true,
        layout: "private",
        fab: true
      }
    },
    {
      path: ROUTES.INVESTMENTS,
      name: "farmFunding",
      component: Investments,
      meta: {
        title: "Farm Funding",
        requiresAuth: true,
        layout: "private",
        forNonInvestors: true
      }
    },
    {
      path: ROUTES.FARMS,
      name: "farms",
      component: Farms,
      meta: {
        title: "Farms",
        requiresAuth: true,
        layout: "private",
        forNonInvestors: true
      }
    },
    {
      path: ROUTES.ACTIVEFARMS,
      name: "activefarms",
      component: ActiveFarms,
      meta: {
        title: "Farms",
        requiresAuth: true,
        layout: "private",
        forNonInvestors: true
      }
    },
    {
      path: ROUTES.OWNERSHIPS,
      name: "farmOwnership",
      component: Ownerships,
      meta: {
        title: "Farm Ownership",
        requiresAuth: true,
        layout: "private",
        forNonInvestors: true
      }
    },

    {
      path: ROUTES.RENTALS,
      name: "farmRental",
      component: Rentals,
      meta: {
        title: "Farm Rentals",
        requiresAuth: true,
        layout: "private",
        forNonInvestors: true
      }
    },

    {
      path: ROUTES.EDIBLES,
      name: "edibles",
      component: Edibles,
      meta: {
        title: "Edibles",
        layout: "private",
        requiresAuth: true
      }
    },
    /**{
      path: ROUTES.INVESTMENT_ABOUT,
      name: "aboutInvestments",
      component: InvestmentAbout,
      meta: {
        title: "About The Investments",
        requiresAuth: true,
        layout: "private",
        forNonInvestors: true
      }
    },**/
    {
      path: ROUTES.WALLET,
      name: "wallet",
      component: Wallet,
      meta: {
        title: "Wallet",
        requiresAuth: true,
        layout: "private"
      }
    },
    {
      path: ROUTES.SLOTS,
      name: "slots",
      component: Slots,
      meta: {
        title: "Investment Slots",
        requiresAuth: true,
        layout: "private"
      }
    },
    {
      path: ROUTES.REFERRALS,
      name: "referrals",
      component: Referrals,
      meta: {
        title: "Referrals",
        requiresAuth: true,
        layout: "private"
      }
    },
    {
      path: ROUTES.PROFILE,
      name: "profile",
      component: Profile,
      meta: {
        title: "Profile",
        requiresAuth: true,
        layout: "private",
        forNonInvestors: true
      }
    },
    {
      path: "*",
      name: "error404",
      component: Error404,
      meta: {
        title: "Page Not Found"
      }
    }
  ]
});

// Route Guards before every navigation
router.beforeEach((to, from, next) => {
  store.dispatch("ui/toggleMobileMenu", false);
  

  // const requiresAuth = to.matched.some(record => record.meta.requiresAuth); TODO: check why it's done like this in docs
  const { requiresAuth } = to.meta;
  if (requiresAuth === true && !isUserLoggedIn()) {
    next(`/login?next=${to.path}`);
  } else if (requiresAuth === false && isUserLoggedIn()) {
    next({
      name: "dashboard"
    });
  } else {
    next();
  }
});

router.afterEach(to => {
  document.title = `${to.meta.title || "App"} | Agbeloba`;
});

export default router;
